import React from 'react';
import Button from "../button";
import LoiCard from "./loiCard";
import RangeInput from "../General/RangeInput";
import WizardClientDetails from "./wizardClientDetails";
import _ from  'lodash';
import CenteredDots from "../General/centeredDots";
import FormResponseMessage from "../formResponseMessage";
import accounting from "accounting";
import CustomModal from "../General/customModal";
import QuotePolicyOverview from "./quotePolicyOverview";
import { CURRENCY } from '../../helpers/variables';

class WizardStep2 extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            isPolicyOverviewModalOpen: false
        }
    }

    _openPolicyOverviewModal = () => {
        this.setState({
            ...this.state,
            isPolicyOverviewModalOpen: true
        })
    };

    _closePolicyOverviewModal = () => {
        this.setState({
            ...this.state,
            isPolicyOverviewModalOpen: false
        })
    };

    componentDidMount(){
        this.props.getQuoteDefaultSettings();
    }

    render(){
        const agentCommissionMessage = this.props._getQuoteMessageByPosition('QuickQuotePart2BrokerSection');
        const nextMessage = this.props._getQuoteMessageByPosition('QuickQuotePart2NextText');
        const quoteValidMessage = this.props._getQuoteMessageByPosition('QuickQuotePart2QuotationsValidPeriod');
        return (
            <div>
                <CustomModal
                    contentClassname='tobas__toba-modal'
                    isOpen={this.state.isPolicyOverviewModalOpen}
                    content={
                        <QuotePolicyOverview
                            {...this.props}
                            _closePolicyOverviewModal={this._closePolicyOverviewModal}
                        />
                    }
                    handleClose={this._closePolicyOverviewModal}
                />
                <WizardClientDetails
                    {...this.props}
                />
                <div className="row">
                    <div className="col-sm-12">
                        <hr className=" applicationPolicy-hr"/>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col-sm-12'}>
                        <div className={'loiCard__wrapper'}>
                            {
                                _.map(this.props.products, (product, key) => {
                                    return (
                                        <LoiCard
                                            key={key}
                                            {...this.props}
                                            label={product.masterProductName}
                                            productInfo={this.props._getQuoteProductInfo(product.masterProductId)}
                                            productId={product.masterProductId}
                                            loi={product.commercialRates.map(item => ({
                                                key: item.limitOfIndemnity,
                                                value: accounting.formatMoney(parseFloat(item.limitOfIndemnity), `${CURRENCY} `, 2)
                                            }))}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className={'col-sm-12 mt-15'} dangerouslySetInnerHTML={{__html: quoteValidMessage.body}}>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <hr className=" applicationPolicy-hr"/>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col-sm-12 mb-15'}>
                        <div className={'quote-wizard__agent-commission-header'}>{agentCommissionMessage.title}</div>
                    </div>
                    <div className={'col-sm-12 mb-15'} dangerouslySetInnerHTML={{__html: agentCommissionMessage.body}}>
                    </div>
                    <div className={'col-sm-12 mb-15'}>
                        <div style={{verticalAlign: 'middle', display: 'inline-block'}} >
                            <span>{'Agent commission: '}</span>
                            <div className={'quote-wizard__agent-commission'}>{this.props.agentCommission}</div>
                            <span>{' %'}</span>
                        </div>
                        <Button
                            clickHandler={this.props.resetQuoteOptions}
                            wrapper="btn-wrapper pull-right"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp white'}
                            label="Reset"
                        />
                    </div>
                    <div className={'col-sm-12 mb-15'}>
                        <RangeInput
                            value={this.props.agentCommission}
                            name={'agentCommission'}
                            min={0.0}
                            max={25.0}
                            step={0.1}
                            onChange={evt => {
                                this.props.changeBrokerCommission({key: evt.target.name, value: evt.target.value})
                            }}
                        />
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col-sm-12 mb-15'} dangerouslySetInnerHTML={{__html: nextMessage.body}}>
                    </div>
                    <div className={'col-sm-12'}>
                        <Button
                            clickHandler={this.props._handleQuoteOptionsSubmit}
                            wrapper="btn-wrapper"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Next"
                        />
                        <Button
                            clickHandler={this._openPolicyOverviewModal}
                            wrapper="btn-wrapper"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp blue'}
                            label="Policy Overview"
                        />
                    </div>
                </div>
                {this.props.updating && (
                    <div className={'col-sm-12'}>
                        <CenteredDots/>
                    </div>
                )}
                {this.props.updateErrorMessage && (
                    <div className={'row mt-15'}>
                        <FormResponseMessage
                            Message={this.props.updateErrorMessage}
                            CenterWrapper="col-sm-12"
                            MessageStyle="formResponseMessage-reject"
                        />
                    </div>
                )}
            </div>
        )
    }
}

export default WizardStep2;